import React, { useState, useEffect } from "react";
import Text from "../../components/Text";
import {
  RightWrapper,
  TextWrapper,
  CastlePageWrapper,
  LeftWrapper,
  ImageGallery,
  Close,
  SidePageIcon,
  // ArrowRight,
  // ArrowLeft,
} from "./CastleDetails.style";
import { Overlay } from "../../components/Modals/modals.style";
import CloseIcon from "../../assets/close-button.png";
import Pageside from "../../assets/page-side.png";
// import Arrow from "../../assets/next.png";
import Button from "../../components/Button";
import { fetchCastleData } from "../../API/castles"; // Backend API call function

const CastlePage = ({ open, handleClose, castleId }) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false); // Track loading state
  const [error, setError] = useState(null); // Track any errors

  // Fetch questions from the backend when the modal opens
  useEffect(() => {
    const fetchQuestions = async () => {
      if (!castleId || !open) return;

      setLoading(true);
      try {
        const data = await fetchCastleData(castleId);
        setQuestions(data);
        setCurrentQuestionIndex(0); // Reset to the first question
      } catch (err) {
        setError("Failed to load questions.");
        console.error("Error fetching questions:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchQuestions();
  }, [castleId, open]);

  const nextQuestion = () => {
    setCurrentQuestionIndex((prevIndex) => (prevIndex + 1) % questions.length);
  };

  const prevQuestion = () => {
    setCurrentQuestionIndex(
      (prevIndex) => (prevIndex - 1 + questions.length) % questions.length
    );
  };

  const currentQuestion = questions[currentQuestionIndex];

  // if (!open) return null;

  return (
    <>
      <Overlay />
      <CastlePageWrapper>
        <LeftWrapper>
          <div style={{ height: "100%", position: "relative" }}>
            {/* <ArrowLeft src={Arrow} alt="Previous" onClick={prevQuestion} /> */}
            <ImageGallery
              src="https://via.placeholder.com/600" // Placeholder for an image
              alt={`Question ${currentQuestionIndex + 1}`}
            />
            {/* <ArrowRight src={Arrow} alt="Next" onClick={nextQuestion} /> */}
          </div>
        </LeftWrapper>

        <RightWrapper>
          <Close
            src={CloseIcon}
            alt="Close"
            onClick={() => handleClose(false)}
          />
          <div
            style={{
              padding: "0 160px 30px 45px",
              display: "flex",
              flexDirection: "column",
              flex: "1",
            }}
          >
            {loading ? (
              <Text
                fontFamily="Alegreya"
                fontWeight="700"
                fontSize="30px"
                lineheight="40px"
              >
                Loading questions...
              </Text>
            ) : error ? (
              <Text
                fontFamily="Alegreya"
                fontWeight="700"
                fontSize="30px"
                lineheight="40px"
                color="red"
              >
                {error}
              </Text>
            ) : currentQuestion ? (
              <>
                <Text
                  fontFamily="Alegreya"
                  fontWeight="700"
                  fontSize="30px"
                  lineheight="40px"
                >
                  Question {currentQuestionIndex + 1}
                </Text>
                <TextWrapper>
                  <Text
                    fontFamily="Manrope"
                    fontWeight="400"
                    fontSize="18px"
                    lineheight="22px"
                  >
                    {currentQuestion.question}
                  </Text>
                </TextWrapper>
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {currentQuestion.options.map((option, idx) => (
                    <Button key={idx}>{option}</Button>
                  ))}
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    marginTop: "60px",
                    justifyContent: "center",
                  }}
                >
                  <Button onClick={prevQuestion}>Previous</Button>
                  <Button onClick={nextQuestion}>Next</Button>
                </div>
              </>
            ) : (
              <Text
                fontFamily="Alegreya"
                fontWeight="700"
                fontSize="30px"
                lineheight="40px"
              >
                No questions available.
              </Text>
            )}
          </div>
          <SidePageIcon src={Pageside} alt="" />
        </RightWrapper>
      </CastlePageWrapper>
    </>
  );
};

export default CastlePage;
